export class OpenMenuOnDesktop {
    constructor(optionalOptions = {}) {
        this._menuItems = document.querySelectorAll('.menu-item--choose');

        if (!this._menuItems) {
            this.destructor();
            return true;
        }

        this._menuItems.forEach((item) => {
            item.addEventListener("click", (e) => {
                e.preventDefault();
                item.querySelector('.menu-list-item--add').click();
                document.querySelector('body').classList.add('no-scroll');

                return false;
            })
        })
    }

    destructor() {
        this._menuItems = null;
    }
}

export default new OpenMenuOnDesktop();
